module.exports = __webpack_public_path__ + "img/about-scale3.d5dd0f00.jpg";